import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as CompanyInfoActions from './company-info.actions';
import { CompanyInfo } from '../../customer-admin.model';

export const companyInfoFeatureKey = 'CompanyInfo';

export interface State extends EntityState<CompanyInfo> {
    // additional entities state properties
}

export const adapter: EntityAdapter<any> = createEntityAdapter<CompanyInfo>({
    selectId: (model: CompanyInfo) => `${model.CustomerID}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

export const CompanyInfoReducer = createReducer(
    initialState,
    on(CompanyInfoActions.addCompanyInfo, (state, action) =>
        adapter.addOne(action.CompanyInfo, state)
    ),
    on(CompanyInfoActions.upsertCompanyInfo, (state, action) =>
        adapter.upsertOne(action.JsonString, state)
    ),
    on(CompanyInfoActions.addCompanyInfos, (state, action) =>
        adapter.addMany(action.CompanyInfos, state)
    ),
    on(CompanyInfoActions.upsertCompanyInfos, (state, action) =>
        adapter.upsertMany(action.CompanyInfos, state)
    ),
    on(CompanyInfoActions.updateCompanyInfo, (state, action) =>
        adapter.updateOne(action.CompanyInfo, state)
    ),
    on(CompanyInfoActions.updateCompanyInfos, (state, action) =>
        adapter.updateMany(action.CompanyInfos, state)
    ),
    on(CompanyInfoActions.deleteCompanyInfo, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(CompanyInfoActions.deleteCompanyInfos, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(CompanyInfoActions.loadCompanyInfos, (state, action) =>
        adapter.setAll(action.CompanyInfos, state)
    ),
    on(CompanyInfoActions.clearCompanyInfos, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return CompanyInfoReducer(state, action);
}

export const selectCompanyInfoState = createFeatureSelector<State>(
    companyInfoFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectCompanyInfoState);
